import { Button, createTheme, Paper, Stack, styled, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import BorderLinearProgressWithLabel from '../../common/BorderLinearProgress';
import { EditProcessProcedureCompleted } from '../EditProcessProcedureCompleted';
import { ReadOnlyProcessProcedureCompleted } from '../ReadOnlyProcessProcedureCompleted';
import { calculateCompletionPercentage } from '../../../utils/helper';

const LeadOwners = ({ editProcessProcedureCompoleted, leadDetails, handleEditProcessProcedureCompoleted }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const CustomButton = styled(Button)({
    backgroundColor: '#F07B0E',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#f1785a',
    },
    width: 'fit-content',
    alignSelf: isSmallScreen ? 'center' : 'end',
  });
  return (
    <>
      <Stack>
        <Paper>
          <Stack
            direction={'row'}
            sx={{
              borderBottom: '1px solid #c7c7c7',
              px: '30px',
              py: '20px',
              backgroundColor: '#cce6e6',
            }}
          >
            <Typography sx={{ fontWeight: '600', alignSelf: 'start' }} component="p">
              Process & Procedure Completed
            </Typography>
            {editProcessProcedureCompoleted ? (
              ''
            ) : (
              <CustomButton
                sx={{ ml: 'auto' }}
                variant="contained"
                size="small"
                onClick={handleEditProcessProcedureCompoleted}
              >
                Edit
              </CustomButton>
            )}
          </Stack>
          <BorderLinearProgressWithLabel
            color="primary"
            variant="determinate"
            value={calculateCompletionPercentage(leadDetails, [
              'siteCondition',
              'howDidYouKnowAboutUs',
              'processCompleted',
            ])}
          />
          {editProcessProcedureCompoleted ? (
            <EditProcessProcedureCompleted
              details={leadDetails}
              leadId={leadDetails.id}
              handleEditDetails={handleEditProcessProcedureCompoleted}
            ></EditProcessProcedureCompleted>
          ) : (
            <ReadOnlyProcessProcedureCompleted details={leadDetails}></ReadOnlyProcessProcedureCompleted>
          )}
        </Paper>
      </Stack>
    </>
  );
};

export default LeadOwners;
